<script setup>
import { Button as FButton } from "frappe-ui";
import { useBSidebarToggle } from "@/dokos-ui/composables/useBSidebarToggle";
const { asRef: visible, toggle } = useBSidebarToggle();
</script>

<template>
  <div style="display: var(--BSidebarToggle--display, none);">
    <FButton :icon="visible ? 'x' : 'menu'" @click="toggle" />
  </div>
</template>
